// extracted by mini-css-extract-plugin
export default {"radio":"HVRadio_module-SPCH6U2J_radio__jl5i5","icon":"HVRadio_module-SPCH6U2J_icon__jTvBe","label":"HVRadio_module-SPCH6U2J_label__pmZY-"};